//export const URL = "http://192.168.1.33:8000"; //testing
export const URL = "https://myadmin.121five.com"; //prod

export const SLIDER = `${URL}/api/slider`;
export const BANNER = `${URL}/api/banner`;
export const HEADLINE = `${URL}/api/headline`;
export const NEWS = `${URL}/api/news`;
export const GALLERY = `${URL}/api/gallery`;
export const ABOUT_US = `${URL}/api/about`;
export const CONTACT_US = `${URL}/api/contact`;
export const INSTITUTE = `${URL}/api/institute`;
export const COMPANY = `${URL}/api/company`;
export const REGISTER_USER = `${URL}/api/sponsor`;
export const LOGIN = `${URL}/api/sponsor-login`;
export const SPONSOR = `${URL}/api/sponsor`;
export const TYPE = `${URL}/api/type`;
export const CATEGORY = `${URL}/api/category`;
export const SPONSOR_POST = `${URL}/api/get-sponsor-post/`;
export const SPONSOR_COMPANY_REGISTRATION = `${URL}/api/sponsor`;
export const GET_SPONSOR_COUNT = `${URL}/api/get-sponsor-count`;
export const SUBSCRIPTION = `${URL}/api/subscription`;
export const FEATURES_IN_DEPTH = `${URL}/api/features`;
export const CONTACT_US_DATA = `${URL}/api/contact-us`;
export const SEARCH_POST = `${URL}/api/get-search-post`;
export const PAYMENT = `${URL}/api/payment`;
export const CONTRIBUTORS = `${URL}/api/contributors`;
export const PHOTOGRAPHER = `${URL}/api/photographer`;
export const NEW_BLOG_LIMIT = `${URL}/api/all-news`;
export const PHOTOGRAPHER_GALLERY = `${URL}/api/gallery-image`;
export const CHECK_PAYMENT = `${URL}/api/checkPayment`;
export const USER_COMMENT = `${URL}/api/comments`;
